'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _handleActions;

var _reduxActions = require('redux-actions');

var _buildMessageKey = require('conversations-schema/pubnub-message/operators/buildMessageKey');

var _ThreadHistory = require('conversations-schema/thread-history/ThreadHistory');

var _ThreadHistory2 = _interopRequireDefault(_ThreadHistory);

var _addMessageToThreadHistory = require('../../thread-histories/operators/addMessageToThreadHistory');

var _StubbedThreadHistoryActionTypes = require('../constants/StubbedThreadHistoryActionTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = new _ThreadHistory2.default();

exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _StubbedThreadHistoryActionTypes.ADD_MESSAGE_TO_STUBBED_CHANNEL, function (state, action) {
  var message = action.payload.message;


  var messageKey = (0, _buildMessageKey.buildMessageKey)(message);

  return (0, _addMessageToThreadHistory.addMessageToThreadHistory)(messageKey, message, state);
}), _defineProperty(_handleActions, _StubbedThreadHistoryActionTypes.RESET_STUBBED_CHANNEL, function () {
  return initialState;
}), _handleActions), initialState);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/stubbed-thread-history/reducers/stubbedThreadHistory.js
// module id = 894
// module chunks = 2 3